import { useCallback } from 'react'
import { useApolloClient } from 'apollo-client'
import type { ProductOfMonthKind } from 'typings/graphql'
import afterPaymentUpdateQuery, { type AfterPaymentUpdateVariables } from './graph/afterPaymentUpdate.graphql'


type Options = AfterPaymentUpdateVariables & {
  enableAddons?: boolean
}

// we update user data after a purchase with some additional optimizations
export const useAfterPaymentUpdate = () => {
  const client = useApolloClient()

  return useCallback(async (options: Options) => {
    const addons: ProductOfMonthKind[] = [ 'CASE', 'CAR_SCENT', 'CANDLE' ]
    const { enableAddons = false, withSubscription = false, withAddressInfo = true } = options

    // enable all subscription addons
    if (enableAddons) {
      addons.forEach((kind) => {
        client.cache.modify({
          id: client.cache.identify({ __typename: `CaseSubscription`, kind }),
          fields: {
            enabled() {
              return true
            },
          },
        })
      })
    }

    await client.query({
      // we need to reload it
      fetchPolicy: 'network-only',
      query: afterPaymentUpdateQuery,
      variables: {
        withSubscription,
        withAddressInfo,
      },
    })
  }, [ client ])
}
